import { render, staticRenderFns } from "./notPlannedPickups.vue?vue&type=template&id=5ec0d866"
import script from "./notPlannedPickups.vue?vue&type=script&lang=js"
export * from "./notPlannedPickups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports